import { conf } from '../config/config';
import { DEMO_MODE } from '../util/Constants';
import { getLocalStore } from '../util/Helpers';

const loginEndpoint = `${conf.endpoint.replace(/\/$/, '')}/api/auth/login`;
export const MODEL_ROLE_ID = 2;

export async function loginModel(email, password) {
    if (getLocalStore(DEMO_MODE, false, true)) {
        return {
            accessToken: null,
            token: null,
            user: {uuid: 'demo-model-user', role: MODEL_ROLE_ID, model: 'demo-model-profile'}
        };
    }

    const response = await fetch(loginEndpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email: email.trim(), password, role: MODEL_ROLE_ID})
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(result.error?.message || 'We could not sign you in. Please check your credentials.');
    }

    const data = result.data;
    if (!data?.accessToken) {
        throw new Error('Login response did not include an access token.');
    }

    if (Number(data.user?.role) !== MODEL_ROLE_ID) {
        throw new Error('This login is only available to model accounts.');
    }

    return data;
}
